@if (loading) {
  <div>Loading...</div>
}

@if (!loading) {
  <div class="content-container">
    <div class="outer-container">
      <div id="carousel" class="carousel showmanymoveone" data-interval="false" data-wrap="false">
        <div class="carousel-inner">
          @for (do of dos; track do; let i = $index) {
            <div [ngClass]="{'active': i == page, 'first-dos': i == 0, 'is-education' : education, 'is-not-education': !education }"
              class="carousel-item"
              >
              <div style="height:40px;"></div> <!-- to prevent jankyness when sliding -->
              <div class="dos-and-donts-container">
                <div class="left-content">
                  <div class="dos-and-donts-text">
                    <div  class="dos-and-donts-comment">
                      @if (i>0) {
                        <h2 class="page-indicator">{{i}} / {{dos.length -1 }}</h2>
                      }
                      @if (do.title) {
                        <h2 [innerHTML]="do.title"></h2>
                      }
                      @if (!do.title) {
                        <h2 class="pagination">{{getPagination(i)}}</h2>
                      }
                      @for (p of do.commentParagraphs; track p) {
                        <p [innerHTML] = "p.value"> </p>
                      }
                    </div>
                    @if (do.helperImage != '') {
                      <img [src]="'../../../assets/img/' + do.helperImage" class="helperImage" alt="Image of a button that can be toggled"/>
                    }
                    @if (i>0) {
                      <app-add-action [isReminder]="itemName === 'Reminders'" [events]="eventsSubject.asObservable()" [added]="do.added" [actionObject]="do" (addAction)="onAddAction($event)"></app-add-action>
                    }
                  </div>
                </div>
                <div class="dos-and-donts-image" [ngStyle]="{ 'background-image': 'url(' + baseUrl + '/actions-images/' + do.image + ')'}" alt="doodle"></div>
              </div>
            </div>
          }
          <div [ngClass]="{'carousel-item': true,  'active': haveFinish }">
            <div [ngClass]="{'dos-and-donts-container my-actions': true,  'is-education': education}">
              <h2>Now select your Hemisphere {{itemName}}</h2>
              <div data-testid="actions-summary" class="actions-summary">
                @for (do of onlyDos; track do) {
                  <app-add-action [events]="eventsSubject.asObservable()" [added]="do.added" [withTitle]="true" [actionObject]="do" (addAction)="onAddAction($event)"></app-add-action>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      @if (haveBack) {
        <button id='back' id="back" (click)="onBack()" class="btn btn-outline-primary btn-outline next" autofocus>Back</button>
      }
      @if (haveNext) {
        <button id='next' (click)="onNext()" class="btn btn-outline-primary btn-outline next" autofocus>Next</button>
      }
      @if (haveFinish) {
        <button id='finish' (click)="onFinish()" class="btn btn-outline-primary btn-outline next" autofocus>{{finishButtonText}}</button>
      }
    </div>
  </div>
}
<app-progress-bar [progressValue]=controller.getProgress()></app-progress-bar>
